import * as moment from 'moment';

import { ACTIONS as INVOICE_ACTIONS } from '@teem/constants/invoice';
import { messages as i18n } from '@teem/constants/messages';
import { getAcronym } from '@teem/helpers/functions';
import * as Api from '@teem/constants/api';
import { RemoveUnderscorePipe } from '@teem/pipes/remove-underscore.pipe'
import { TitleCasePipe } from '@angular/common';

export class FailedPaymentTableSchema {
  containerContext: any;
  userInfo: any = (window as any).userInfo;
  keyColumn: string = 'uuid';
  serverUrl: string = `${Api.invoice.received_payments}?tab=failed`;
  headers: Array<object> = [
    { "label": "#", "thClass": "th-number" },
    { "label": $localize`:@@ts.date:Date`, "thClass": "th-date" },
    { "label": $localize`:@@ts.client:Client`, "thClass": "th-client" },
    // { "label": $localize`:@@ts.project_name:Project Name`, "thClass": "th-project" },
    { "label": $localize`:@@invoices.amount_due:Amount Due`, "thClass": "th-amountReceived" },
    { "label": $localize`:@@ts.type:Type`, "thClass": "th-type" },
    { "label": $localize`:@@ts.status:Status`, "thClass": "th-payment" },
    { "label": $localize`:@@ts.payment_ref_id:Payment Ref/ID`, "thClass": "th-bayanPay" },
    // { "label": $localize`:@@ts.accept_rejected:Accept/Reject`, "thClass": "th-editdelete text-center" },
  ];
  cols: Array<object> = [
    { 
      "key": "invoice_number", "tdClass": "td-number",
      "render": (value) => {
        return `<a href="javascript:void(0);" class="invoice_number"> ${value}</a>`
      },
      "dataClick": (e, value?: any, row?: any) => {
        if (e.target.classList.contains('invoice_number')) {
          this.containerContext.invoiceActions(INVOICE_ACTIONS.VIEW, row);
        }
      },
    },
    {
      "key": "date", "tdClass": "td-date",
      "render": (value) => {
        let d = moment(value);
        if (d.isValid()) {
          return (`
						<div class="date">
							<span class="day">${d.format('DD')}</span>
							<span class="month">${d.format('MMM')}</span>
							<span class="year">${d.format('YYYY')}</span>
						</div>`
          );
        }

        return '';
      }
    },
    {
      "key": "client_name", "tdClass": "td-client-name",
      // "render": (value) => `<span class="name-alpha">${getAcronym(value)}</span>${value}`
    },
    {
      "key": "amount",
      "tdClass": "td-amount",
      "render": (value, row) => {
				let currency = row.currency ? row.currency : this.userInfo.currency_symbol;
        return `<div class="amount">
                            <span class="sar">${currency}</span>
                            <span class="price">${value ? value : 0}</span>
                        </div>`
        //return this.containerContext.currencyPipe.transform(value ? value : 0)
      }
    },
    { 
			"key": "payment_type", 
			"tdClass": "td-type", 
			"render": (value) => `${ value ? new TitleCasePipe().transform(new RemoveUnderscorePipe().transform(value)) : '' }` 
		},
    {
      "key": "status", "tdClass": "td-payment",
      "render": (value, row) => {
        let status = i18n[value] ? i18n[value] : value;
        let colorClass = 'font-weight-bold';
        if (value == 'accepted') {
          colorClass = 'status-tag success';
        } else if (value == 'pending') {
          colorClass = 'status-tag warning';
        } else if (value == 'rejected') {
          colorClass = 'status-tag highlight';
        } else if (value == 'unsuccessful') {
          colorClass = 'status-tag highlight';
        }

        return `<span class="${colorClass}" >${status}</span>`;
      }
    },
    {
      "key": "payment_refer_number",
      "tdClass": "td-bayanPay font-weight-bold text-truncate",
      "render": (value, row) => {
        if (row.payment_type == 'Bank-transfer') {
          return `<span class="bt-content">
            <a class="icon-link" href="storage/${row.attachment_path}" target="_blank">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <path d="M8.683 6.042h12.782a.797.797 0 0 0 .794-.799.797.797 0 0 0-.794-.799H8.683a.797.797 0 0 0-.794.8c0 .44.356.798.794.798M22.26 10.243a.797.797 0 0 0-.795-.799H8.683a.797.797 0 0 0-.794.8c0 .44.355.798.794.798h12.782a.797.797 0 0 0 .794-.799"></path>
                    <path d="M28.571 37.997c-5.32 0-9.647-4.175-9.647-9.306 0-5.132 4.328-9.307 9.647-9.307 5.32 0 9.648 4.175 9.648 9.307 0 5.131-4.328 9.306-9.648 9.306zM3.123 32.221c-.35 0-.646-.272-.646-.595V13.633c0-.322.296-.595.646-.595h9.389c.35 0 .646.273.646.595v.4c0 1.21 1.002 2.194 2.234 2.194h12.462c.35 0 .646.272.646.594v.967c-6.162.037-11.164 4.913-11.164 10.903 0 1.235.215 2.422.607 3.53H3.123zM5.778 2.042H25.2V14.63h-9.808c-.35 0-.646-.273-.646-.595v-.4c0-1.21-1.002-2.194-2.234-2.194H5.778V2.042zm24.31 15.846v-1.067c0-1.209-1.002-2.192-2.234-2.192h-1.066V1.243a.797.797 0 0 0-.794-.799H4.984a.797.797 0 0 0-.795.8V11.44H3.123c-1.232 0-2.234.984-2.234 2.193v17.993c0 1.21 1.002 2.193 2.234 2.193H18.66c1.894 3.434 5.626 5.776 9.912 5.776 6.196 0 11.236-4.891 11.236-10.904 0-5.514-4.238-10.081-9.718-10.803z"></path>
                    <path d="M28.94 27.963c-1.608-.643-2.293-1.109-2.293-2.041 0-.717.536-1.54 1.96-1.54 1.185 0 1.944.393 2.333.609l.463-1.182c-.538-.305-1.295-.59-2.406-.626v-1.739H27.85v1.81c-1.701.269-2.794 1.397-2.794 2.883 0 1.558 1.166 2.382 3.054 3.098 1.37.537 2.09 1.146 2.09 2.131 0 1.022-.887 1.755-2.202 1.755a5.052 5.052 0 0 1-2.664-.77l-.444 1.2c.647.448 1.758.77 2.83.788v1.81h1.167v-1.865c1.906-.302 2.923-1.629 2.923-3.043 0-1.594-.962-2.525-2.868-3.278"></path>
                </svg>
            </a>
        </span>`;
        }
        let t = value ? value : i18n.na;
        return `<span title="${t}">${t}</span>`;
      }
    }
    
  ];

  constructor(container: any) {
    this.containerContext = container;
  }
}

